import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import "./MarkerGuessTable.scss";
import { Edit } from "@mui/icons-material";
const MarkerGuessTable = ({
  guessData = [],
  handleEdit,
  level = "intermediate",
}) => {
  const bgClass = (correct) => {
    if (correct) {
      return "is-correct";
    } else if (correct === false) {
      return "is-incorrect";
    }
    return "";
  };

  return (
    <TableContainer className={`marker-table ${level}`}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>No.</TableCell>
            <TableCell>X</TableCell>
            <TableCell>Y</TableCell>
            <TableCell>ALT</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {guessData.map((packet, index) => (
            <TableRow key={index} className={`${bgClass(packet.correct)}`}>
              <TableCell>{index + 1}</TableCell>
              {/* <TableCell>{formatTimeOnly(packet.time)}</TableCell> */}
              <TableCell> {packet.loc_x}</TableCell>
              <TableCell> {packet.loc_y}</TableCell>
              <TableCell>{packet.alt}</TableCell>
              <TableCell>
                {!packet.correct && (
                  <IconButton onClick={() => handleEdit(index)}>
                    <Edit color="currentColor" sx={{ fontSize: "1rem" }} />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MarkerGuessTable;
